<template>
<div class="form">
<a-card title="分组编辑">
        <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">

            <a-form-model-item label="分组名" prop="groupname" :labelCol="labelCol"
                :wrapperCol="wrapperCol" style="width:100%;margin-top:10px;">
                <a-input v-model="record.groupname" type="textarea" />
            </a-form-model-item>

            <a-form-model-item   :wrapper-col="{ span: 14, offset: 10 }" >
                <a-button type="primary" @click="handleOk">
                    保存
                 </a-button>

                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>
  
</template>
<script>
import { mapState } from "vuex";

export default {
    data() {
        return {
            is_vue_task : false,
            labelCol: {span: 3},
            wrapperCol: {span: 14},
            rules: {
                name: [
                    {required: true, message: '请输入分组名称', trigger: 'blur'},
                    {max: 50, message: '不能超过50位', trigger: 'blur'},
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal',
            syslist:[],
            tLoading1:false,
            actiontype:''
        };
    },
    computed: {
        ...mapState("alarmmanager", {
            record: function(state) {
                console.log("this.a====>"+this.actiontype);
                return this.actiontype == "groupadd" ? {
                    groupname: ''
                } : state.record;
            }
        })
    },

    methods: {
        handleOk() {
            this.confirmLoading = true;
            if (this.actiontype == "groupadd"){
               
                //新增
                this.$store
                    .dispatch({
                        type: "alarmmanager/groupadd" ,
                        params: this.record
                    })
                    .then((response) => {
                        if (response.data.success == '1') {
                            this.$router.push({
                                path: "grouplist"
                            });
                        }

                    });
            }else{
                //编辑
                this.record.id = this.record.id;
                this.$store
                    .dispatch({
                        type: "alarmmanager/groupedit",
                        params: this.record
                    })
                    .then((response) => {
                        if(response.data.success == '1'){
                            console.log(response)
                            this.handleCancel();
                            this.confirmLoading = false;
                        }
                    });
            }   
            
        },

        handleChange(value) {
            this.record.syscode=value;
        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },

    mounted(){
        const {query, params} = this.$route;
        this.is_vue_task = params.action == 'groupadd';
        this.actiontype=params.action;
        if (params.action != "groupadd") {
            this.$store.dispatch({
                type: "alarmmanager/groupdetails",
                params: query,
                showMsg: false
            })
        }
    },
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
.form_span{
    font-size: 14px;
    font-weight: bolder;
}
</style>
